import { ref } from "vue";
  import * as utils from "@/utils/index";
  export default () => {
    const languageList = ["zh-TW"];
    const pageInfo = {"default":{"title":"累计充值领好礼","ico":""},"zh-TW":{"title":"累計儲值領好禮","ico":""}};

    const languageTxt = {"zh-TW":{"21000":"请先登入帳號","21001":"參數錯誤","21003":"未綁定","21004":"您已經綁定過了","21005":"活動還沒開始，請耐心等待","21006":"活動已結束，謝謝參與","21007":"已經領取該獎勵","21008":"","21009":"您尚未達到領獎條件","21010":"發獎失敗","21011":"","infoBtn":"活動規則","infoTitle":"活動說明","pleaseLogin":"請先登入","bindTitle":"綁定角色","logout":"登出賬號","unBind":"未綁定","myPackage":"我的背包","login":"登入","payTitle":"活動說明","noLogin":"您當前未登錄","loginToCheck":"請先登錄後查看是否滿足領取條件","refresh":"刷新","sure":"確認","totalMoneyTips":"累計充值xxx即可領取","awardInfoBtn":"查看獎勵詳情","nowProgress":"當前儲值進度","noBag":"暫無領獎內容","packageName":"獎勵","packageTime":"領取時間","nowHasMoney":"您符合條件的累計充值額","nowHasMoneyTips":"（匯率有一定變動，請以此頁面展示為準）","common":"請稍後再試","selectServer":"請選擇伺服器","selectRole":"請選擇角色","giftCodeTitle":"恭喜獲得累充獎勵","giftCode":"序列號","copy":"點擊復製","goChange":"前往兌獎","copySucc":"已復製至剪貼板","getBtn":"領取","hasBtn":"已領取","gotoStore":"立即儲值","yourServer":"您的伺服器","allServer":"全部伺服器","changeRole":"","timezone":"活動時間：UTC $start - $end","-1000":"餵餵，夠了啊，這是開加速了麼，這走馬燈是腫麼回事啊，ΣO口O~不如稍作休息吧"},"default":{"21000":"","21001":"","21003":"","21004":"","21005":"","21006":"","21007":"","21008":"","21009":"","21010":"","21011":"","infoBtn":"","infoTitle":"","pleaseLogin":"","bindTitle":"","logout":"","unBind":"","myPackage":"","login":"","payTitle":"","noLogin":"","loginToCheck":"","refresh":"","sure":"","totalMoneyTips":"","awardInfoBtn":"","nowProgress":"","noBag":"","packageName":"","packageTime":"","nowHasMoney":"","nowHasMoneyTips":"","common":"","selectServer":"","selectRole":"","giftCodeTitle":"","giftCode":"","copy":"","goChange":"","copySucc":"","getBtn":"","hasBtn":"","gotoStore":"","yourServer":"","allServer":"","changeRole":"","timezone":"","-1000":""}};
  
    const getSystemLanguage =  ()=>{
      let res = navigator.language || navigator.userLanguage || navigator.browerLanguage || navigator.systemLanguage;
      if (res.indexOf("-") > -1) {
        const langArr = res.split("-");
        res = langArr[0] === "zh" ? langArr[1] : langArr[0];
      }
      return res.toLowerCase();
    };
    const checkLanguage =  (lang) =>{
      let res = "";
      if (lang) {
        if (lang.indexOf("-") > -1) {
          for (let i = 0; i < languageList.length; i++) {
            if (languageList[i] === lang) {
              res = languageList[i];
            }
          }
        } else {
          const reg = new RegExp(lang, "g");
          for (let i = 0; i < languageList.length; i++) {
            if (reg.test(languageList[i].toLowerCase())) {
              res = languageList[i];
            }
          }
        }
      }
      return res;
    };
    let curLang = checkLanguage(utils.getUrlParams("appLanguage")) || checkLanguage(utils.getUrlParams("language")) || checkLanguage(getSystemLanguage()) || checkLanguage("zh-TW") || "default";
    const initLang = () => {
      document.body.className += " " + curLang;
      document.getElementsByTagName("html")[0].setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");
      
      if(!pageInfo[curLang]) return;
      if(pageInfo[curLang].title){
        document.title = pageInfo[curLang].title;
      }
      if(pageInfo[curLang].ico){
        try{
          document.getElementById("icon").setAttribute("href", pageInfo[curLang].ico);
          document.getElementById("shortcut").setAttribute("href", pageInfo[curLang].ico);
        }catch(e){}
      }
    };

    const getLangTxt = (key,msg)=>{
      let info = languageTxt[curLang] || languageTxt.default;
      return info[key] || String(msg);
    }
  
    return { curLang, initLang, getLangTxt, langData:languageTxt[curLang]||{} };
  };
  